export enum SphLeadSourceEnum {
  LeadContact = 1,
  LeadCustomer = 2,
  LeadContactLink = 3,
  LeadVehicle = 4,
  Valuation = 5
}
